import {Col, Container, Row} from "react-bootstrap";
import {Link} from "react-router-dom";

const Footer = () => {
    return (
        <Container fluid>
            <footer className="text-center py-3 bg-dark text-light">
                <Container>
                    <Row>
                        <Col md={4}></Col>
                        <Col md={4}>
                            <h5>
                                <Link to="/" className="text-light me-3">
                                    Startseite
                                </Link>
                                <Link to="/Impressum#start" className="text-light me-3">
                                    Impressum
                                </Link>
                                <Link to="/Datenschutz#start" className="text-light ">
                                    Datenschutz
                                </Link>
                            </h5>
                        </Col>
                        <Col md={4}></Col>
                    </Row>
                    <p className="mt-3">
                        &copy; 2024 Michaela Diener
                    </p>
                </Container>
            </footer>
        </Container>
    );
};
export default Footer;
